export enum CtaTexts {
  GET_STARTED = 'Get started',
  GET_STARTED_WITH_DISCOUNT = 'Get started with 60% off',
  OPEN_MENU = 'Open Menu',
  BUILD_BOX = 'Build your box',
  BUILD_BOX_WITH_DISCOUNT = 'Build your box with 60% off',
}
